export const SOCIAL_LINKS_SECTION_ID = 'social-links-section';
